import React from "react";
import Scrollbars from "react-custom-scrollbars";
import { useSelector } from "react-redux";
import { Dimmer, Loader, Progress, Icon } from "semantic-ui-react";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import NoData from "../../Dashboard/Charts/NoData/NoData";
import { numberWithCommas } from "../../Dashboard/Charts/utils";
import "../../Dashboard/Charts/TopInfluencers/TopInfluencers.scss";
import ChartName from "../../Dashboard/Charts/ChartName";
import moment from "moment";
import { QuestionLists } from "../HomePage/Header/InsightsTabComponent";

// const url_prefix = "https://2020admin.circussocial.com/image/image.php?type=post_author_images&name=";
const url_prefix = "https://2020assets.s3.amazonaws.com/images/post_author_images";
const TopInfluencers = () => {
    const brandTopicObj = useSelector((state) => state.insightsRecommendationReducer.ownBrand);
    const competitorTopicObj = useSelector((state) => state.insightsRecommendationReducer.competitorsBrand);
    const topic1Data = useSelector((state) => state.insightsRecommendationReducer.chartData?.["top-influencers"]?.own);
    const topic1DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoading?.["top-influencers"]?.own);
    const topic2Data = useSelector((state) => state.insightsRecommendationReducer.chartData["top-influencers"]?.competitor);
    const topic2DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoading["top-influencers"]?.competitor);
    const currentPage = useSelector((state) => state.insightsRecommendationReducer.currentPage);

    // let data = useSelector((state) => state.insightsRecommendationReducer.topInfluencers);
    let nodata = false;
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    let range = moment().tz(tz).subtract(7, "days").format("DD-MM-YYYY") + ` to ` + moment().tz(tz).subtract(1, "days").format("DD-MM-YYYY");
    let question = QuestionLists.find((obj) => obj.questionTab === currentPage)?.question || "";

    const getPlatforms = (platforms) => {
        return (
            <div className="platform-icons">
                {platforms.map((platform) => {
                    let platformName = allPlatforms.find((plt) => plt.id === platform.key);
                    platformName = platformName ? platformName.short_name : "";
                    platformName = ["fbcomment", "facebook comments"].includes(platformName) ? "facebook" : platformName;
                    return platformName.length > 0 ? (
                        <Popup
                            key={platform.key}
                            trigger={<img className="platform-icon" src={process.env.PUBLIC_URL + "/icons/charts/platformIcons/" + platformName + ".png"} />}
                            content={getPlatformData(platform)}
                            wide
                            className="top__influencers"
                        />
                    ) : null;
                })}
            </div>
        );
    };
    // const getAvgImpact = (impact, max_avg_impact) => {
    //     let percent = 0;
    //     if (impact.max !== null && impact.avg !== null && impact.max !== 0) {
    //         percent = Math.round((impact.avg / max_avg_impact) * 100);
    //     }
    //     return <Progress className="avg-impact-progress" size="small" percent={percent} success title={impact.avg || 0} />;
    // };
    const getAvgSentiment = (sentiment) => {
        let percent = 0;
        if (sentiment.max !== null && sentiment.avg !== null && sentiment.max !== 0) {
            percent = Math.abs(Math.round((sentiment.avg / 20) * 100));
        }
        return (
            <Progress
                className="avg-impact-progress"
                size="small"
                percent={percent}
                success={sentiment.avg > 0}
                error={sentiment.avg < 0}
                title={(sentiment.avg / 20).toFixed(2)}
            />
        );
    };
    // const getMaxAvgImpact = (data) => {
    //     let maxVal = 0;
    //     data.forEach((e) => {
    //         if (e.impact_stats.avg > maxVal) maxVal = e.impact_stats.avg;
    //     });
    //     return maxVal;
    // };

    const InfluencersChart = (data, loading, topic) => {
        // let max_avg_impact = !data ? 0 : getMaxAvgImpact(data);
        let nodata = !data || (data && data.length === 0);
        data = data && data.slice(0, 5);
        let topicName = topic === "topic1" ? "Top influencer for own brand" : "Top influencer for competitor brand";
        let info =
            topic === "topic1"
                ? "This chart will show you the top 5 influencers which mentioned your brand in the past week "
                : "This chart will show you the top 5 influencers which mentioned your competitor brand in the past week ";

        return (
            <>
                <div className={`dashboard-widget-container ${brandTopicObj && competitorTopicObj ? "" : ""}`}>
                    <div className="dashboard-widget-container-header skiptranslate ocr__owncloud">
                        <ChartName name={topicName} info={info} chatGPT={true} />
                    </div>
                    {loading ? (
                        <div className="no__data__block">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                    ) : !nodata && !loading ? (
                        <div className="dashboard-chart table-wrapper skiptranslate chart__wrapper top__influencers">
                            <Scrollbars autoHide>
                                <div className="top-influencer-table insights__recommendation">
                                    <div className="top-influencer-table-cell heading"></div>
                                    <div className="top-influencer-table-cell heading">Name</div>
                                    <div className="top-influencer-table-cell heading">Total Impact</div>
                                    <div className="top-influencer-table-cell heading">Avg Sentiment</div>

                                    {data &&
                                        data.map((influencer, ind) => {
                                            if (
                                                (influencer.platform_breakups &&
                                                    influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.name) ||
                                                influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.username
                                            ) {
                                                return (
                                                    <>
                                                        <div className="profile-dets top-influencer-table-cell">
                                                            <img
                                                                crossOrigin="anonymous"
                                                                className="user-profile-image"
                                                                src={getProfileImage(influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0])}
                                                                alt=""
                                                            />
                                                            {getPlatforms(influencer.platform_breakups.buckets)}
                                                        </div>
                                                        <div className="authorname top-influencer-table-cell">
                                                            {influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author.name ||
                                                                influencer.platform_breakups.buckets[0].user_latest_post.hits.hits[0]._source.post_author
                                                                    .username}
                                                        </div>
                                                        <div className="total-impact top-influencer-table-cell">
                                                            {numberWithCommas(influencer.impact_stats.sum) || "N/A"}
                                                        </div>

                                                        <div className="one-avg-sentiment top-influencer-table-cell">
                                                            {getAvgSentiment(influencer.sentiment_score_stats.group1.group2)}
                                                        </div>
                                                    </>
                                                );
                                            }
                                        })}
                                </div>
                            </Scrollbars>
                        </div>
                    ) : (
                        <NoData classname="gpt__no__data" />
                    )}
                </div>
            </>
        );
    };

    return (
        <div className="influencers__chart ocr__wordcloud__wrapper column__flex">
            <div className="gptHeader">
                <div className="top">
                    <div>{question} </div>
                </div>
                <div className="lower">{`From date: ${range}`}</div>
            </div>

            {brandTopicObj ? InfluencersChart(topic1Data, topic1DataLoading, "topic1") : null}
            {competitorTopicObj ? InfluencersChart(topic2Data, topic2DataLoading, "topic2") : null}
        </div>
    );
};

export default TopInfluencers;

const allPlatforms = [
    {
        id: "6ce33762-a789-11e4-a34f-74867a1157ba",
        name: "Blog",
        short_name: "blog",
    },
    {
        id: "9341868e-0966-11e7-9283-0656fc34e8c9",
        name: "China-Blogs",
        short_name: "blogschina",
    },
    {
        id: "6ce338bd-a789-11e4-a34f-74867a1157ba",
        name: "Facebook",
        short_name: "facebook",
    },
    {
        id: "669ed73b-3102-11e5-b4bb-22000aa22ef0",
        name: "Facebook Comments",
        short_name: "fbcomment",
    },
    {
        id: "6ce32185-a789-11e4-a34f-74867a1157ba",
        name: "Forums",
        short_name: "forum",
    },
    {
        id: "0a789dba-0967-11e7-9283-0656fc34e8c9",
        name: "China-Forums",
        short_name: "forumschina",
    },
    {
        id: "6ce32c0a-a789-11e4-a34f-74867a1157ba",
        name: "Instagram",
        short_name: "instagram",
    },
    {
        id: "8de7e53a-ad28-11e4-b8cb-22000aa425f3",
        name: "LexisNexis",
        short_name: "lexisnexis",
    },
    {
        id: "6ce32911-a789-11e4-a34f-74867a1157ba",
        name: "News",
        short_name: "news",
    },
    {
        id: "28030c45-0967-11e7-9283-0656fc34e8c9",
        name: "China-News",
        short_name: "newschina",
    },
    {
        id: "7f18d34a-367f-11e9-b7dd-02eebbc40807",
        name: "Q&A",
        short_name: "q&a",
    },
    {
        id: "ba447faa-ad28-11e4-b8cb-22000aa425f3",
        name: "Reddit",
        short_name: "reddit",
    },
    {
        id: "6ce33065-a789-11e4-a34f-74867a1157ba",
        name: "China-Weibo",
        short_name: "weibo",
    },
    {
        id: "6ce32a97-a789-11e4-a34f-74867a1157ba",
        name: "Twitter",
        short_name: "x_icon",
    },
    {
        id: "6ce32d7c-a789-11e4-a34f-74867a1157ba",
        name: "Youtube",
        short_name: "youtube",
    },
    {
        id: "8bbdf46a-3680-11e9-b7dd-02eebbc40807",
        name: "China-WeChat",
        short_name: "wechat",
    },
    {
        id: "b58cda8d-c22d-11e8-b7dd-02eebbc40807",
        name: "LinkedIn",
        short_name: "linkedin_icon",
    },
    {
        id: "1cbacd32-a97d-11ea-89d1-02f9d9f14362",
        name: "TikTok",
        short_name: "tiktok",
    },
];

function getPlatformData(platform) {
    let following = platform.user_latest_post.hits.hits[0]._source.post_author.following
        ? platform.user_latest_post.hits.hits[0]._source.post_author.following
        : "N/A";
    let followers = platform.user_latest_post.hits.hits[0]._source.post_author.followers
        ? platform.user_latest_post.hits.hits[0]._source.post_author.followers
        : "N/A";
    let postCount = platform.user_latest_post.hits.hits[0]._source.post_author.post_count;
    let tweets = platform.user_latest_post.hits.hits[0]._source.post_author.tweets;
    return (
        <section className="popup-content">
            <section>
                <img className="user-profile-image" src={getProfileImage(platform.user_latest_post.hits.hits[0])} alt="" />
                <span>
                    <p className="popup-username"> {platform.user_latest_post.hits.hits[0]._source.post_author.username} </p>
                    <p className="popup-authorname"> {platform.user_latest_post.hits.hits[0]._source.post_author.name} </p>
                </span>
            </section>
            <p className="popup-following"> Following: &nbsp;&nbsp; {following} </p>
            <p className="popup-followers"> Followers: &nbsp;&nbsp; {followers} </p>
            {tweets !== null && tweets !== undefined && platform.key === "twitter" && <p className="popup-tweets"> Tweets: &nbsp;&nbsp; {tweets} </p>}
            {renderPostCount(postCount)}
            <p className="popup-location"> Location: &nbsp;&nbsp; {platform.user_latest_post.hits.hits[0]._source.post_author.location || "N/A"} </p>
        </section>
    );
}
function getProfileImage(post) {
    if (post._source.post_author.media[0].folder && post._source.post_author.media[0].name) {
        return url_prefix + post._source.post_author.media[0].folder.replace("post_author_images", "") + "/" + post._source.post_author.media[0].name;
    } else {
        return process.env.PUBLIC_URL + "/icons/charts/platformIcons/user_blank.png";
    }
}

function renderPostCount(count) {
    if (count) {
        return <p className="popup-post-count"> Post Count: &nbsp;&nbsp; {count} </p>;
    } else {
        return null;
    }
}
